<template>
  <!-- 公司项目 -->
  <div id="enterprise-card">
    <div class="enterprise-card-list">
      <div
        class="box-card"
        v-for="(item, index) in table.tableData"
        :key="index"
      >
        <div style="display: flex;">
          <div class="box-card-avatar">
            <img :src="item.logo" />
          </div>
          <div class="box-card-content">
            <div class="box-card-content-title">{{ item.name }}</div>
            <div class="box-card-content-subtitle">{{ item.slogan }}</div>
            <el-popover placement="top-start" trigger="hover">
              <div style="width: 480px; max-height: 100px ; overflow-y: auto;">
                简介:
                {{ item.description }}
              </div>
              <div slot="reference" class="box-card-content-des">
                简介:
                {{ item.description }}
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="enterprise-card-pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="table.pageData.pageIndex"
        :page-size="table.pageData.pageSize"
        layout="prev, pager, next"
        :total="table.pageData.totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", this.table);
    },
  },
};
</script>

<style lang="less" scoped>
#enterprise-card {
  .enterprise-card-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .box-card {
      width: 49%;
      margin-bottom: 10px;
      box-shadow: 0 0 8px #0000001a;
      border-radius: 4px;
      padding: 20px;
      box-sizing: border-box;
      .box-card-avatar {
        img {
          width: 40px;
          height: 40px;
        }
      }
      .box-card-content {
        text-align: left;
        margin-left: 12px;
        .box-card-content-title {
          font-weight: 500;
          font-size: 18px;
          line-height: 18px;
          color: #111a34;
        }
        .box-card-content-subtitle {
          height: 14px;
          font-size: 14px;
          margin-top: 3px;
          color: #777e95;
        }
        .box-card-content-des {
          height: 60px;
          max-height: 60px;
          font-size: 14px;
          margin-top: 12px;
          color: #777e95;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .enterprise-card-pagination {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
